import { useLocalObservable } from 'mobx-react-lite';
import { useEffect } from 'react';

import { TChatBackground } from 'APP/store/Appearance/Appearance.types';
import Entities from 'STORE';
import { Thread } from 'STORE/Groups/Thread';

interface TChatBackgroundPresenter {
  background: TChatBackground | null;
  chatBackground: TChatBackground;
  setBackground(background?: TChatBackground): void;
}

export function useChatBackgroundPresenter(background?: TChatBackground): TChatBackgroundPresenter {
  const presenter = useLocalObservable<TChatBackgroundPresenter>(() => ({
    background: background || null,

    get chatBackground(): TChatBackground {
      if (presenter.background) {
        return presenter.background;
      }

      const groupId = Entities.GroupsStore.activeGroupId ?? null;
      const group = groupId ? Entities.GroupsStore.getGroupById(groupId) : null;

      const entityIdForBackground =
        group instanceof Thread && group.parentGroup ? group.parentGroup.id : groupId;

      return Entities.appearance.getChatBackgroundForEntity(entityIdForBackground);
    },

    setBackground(background?: TChatBackground): void {
      presenter.background = background || null;
    },
  }));

  useEffect(() => {
    presenter.setBackground(background);
  }, [background]);

  return presenter;
}
